import { ReadonlyURLSearchParams } from 'next/navigation';
import { PublicUrls } from '@bridebook/web/lib/url-helper';

const getWebsiteUrl = (websiteId: string, searchParams?: ReadonlyURLSearchParams) => {
  const guest = searchParams?.get('guest');
  const query = guest ? `?guest=${encodeURIComponent(guest)}` : '';
  return `${PublicUrls.for.main}/${websiteId}${query}`;
};

export default getWebsiteUrl;
